/**
 * Маски и валидация ввода — DOM-free, общие для форм и опросов.
 */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function onlyDigits(s: string): string {
  return s.replace(/\D/g, '');
}

/** Маска телефона РФ: только цифры → +7 (XXX) XXX-XX-XX (буквы не проходят). */
export function maskPhone(raw: string): string {
  let d = onlyDigits(raw);
  if (d.startsWith('8')) d = '7' + d.slice(1);
  if (d && !d.startsWith('7')) d = '7' + d;
  d = d.slice(0, 11);
  const p = d.slice(1);
  if (!p) return d ? '+7' : '';
  let out = '+7';
  if (p.length) out += ' (' + p.slice(0, 3);
  if (p.length >= 3) out += ') ' + p.slice(3, 6);
  if (p.length >= 6) out += '-' + p.slice(6, 8);
  if (p.length >= 8) out += '-' + p.slice(8, 10);
  return out;
}

export function isValidEmail(v: string): boolean {
  return EMAIL_RE.test(v.trim());
}

export function isValidPhone(v: string): boolean {
  return onlyDigits(v).length >= 11;
}
